import { ReactNode } from "react";

import ListItem from "./ListItem";
import styles from "./ListItemCheckbox.module.css";

const ListItemCheckbox: React.FC<ListItemCheckboxProps> = ({
  inputProps,
  title,
  children,
}) => {
  return (
    <ListItem
      wrapperAs="label"
      title={title}
      endElement={
        <>
          <input
            className={styles.checkboxInput}
            type="checkbox"
            {...inputProps}
          />
          <svg viewBox="0 0 16 16" className={styles.checkboxIcon}>
            <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" />
            <path
              d="M4 8.5L6.66667 11L12 6"
              className={styles.checkboxIconCheck}
            />
          </svg>
        </>
      }
    >
      {children}
    </ListItem>
  );
};

type ListItemCheckboxProps = {
  title: ReactNode | string;
  inputProps: React.HTMLProps<HTMLInputElement>;
};

export default ListItemCheckbox;
